import { z } from 'zod';

const namePattern = /^[\p{L}' -]+$/u;

export const contactUsSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(1, 'First name is required')
    .max(50, 'First name must be 50 characters or fewer')
    .regex(namePattern, 'First name contains invalid characters'),
  lastName: z
    .string()
    .trim()
    .min(1, 'Last name is required')
    .max(50, 'Last name must be 50 characters or fewer')
    .regex(namePattern, 'Last name contains invalid characters'),
  email: z
    .string()
    .trim()
    .min(1, 'Email is required')
    .max(254, 'Email must be 254 characters or fewer')
    .email('Invalid email address'),
  message: z
    .string()
    .trim()
    .min(1, 'Message is required')
    .max(2000, 'Message must be 2000 characters or fewer'),
  terms: z.boolean().refine((val) => val, { message: 'You must accept the terms' }),
});

export type ContactUsSchema = z.infer<typeof contactUsSchema>;
